import React, { useState, useRef, forwardRef, useImperativeHandle, useCallback } from 'react';
import { Modal, Button, Form } from 'antd';
import './index.less';
import { useTranslation } from 'react-i18next';
import { cdnUrl } from '@/utils/cdn';
const LOCAL_STORAGE_KEY = 'slerfToolsSafetyAlertLastShownMap';
const DEFAULT_SOURCE = "uniqueSourceId";
const HOLD_DURATION = 1000;

const SecurityNoticeModal = forwardRef((_, ref) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const cbRef = useRef<any>(null);
  const pressTimerRef = useRef<NodeJS.Timeout | null>(null);
  const progressIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const { t,i18n } = useTranslation();

  useImperativeHandle(ref, () => ({
    showModal: (params: any) => {
      const { source , cb } = params;
      const lastShownMap = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
      const lastShown = lastShownMap[source || DEFAULT_SOURCE];
      const now = new Date().getTime();

      if (!lastShown || now - parseInt(lastShown) > (24 * 60 * 60) * 1000) {
        init(params, source || DEFAULT_SOURCE);
      } else {
        cb && cb();
        setIsModalVisible(false);
      }
    },
    hideModal: () => {
      setIsModalVisible(false);
    },
  }));

  const init = (params: any, source: string) => {
    const { cb } = params;
    setIsModalVisible(true);
    cbRef.current = { cb, source: source || DEFAULT_SOURCE };
  };

  const handleOk = () => {
    if (cbRef.current) {
      const { cb, source } = cbRef.current;
      cb();
      const now = new Date().getTime();
      const lastShownMap = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
      lastShownMap[source || DEFAULT_SOURCE] = now.toString();
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(lastShownMap));
    }
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const startProgress = useCallback(() => {
    setProgress(0);
    
    // 每50ms更新一次进度
    progressIntervalRef.current = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + (50 / HOLD_DURATION) * 100;
        if (newProgress >= 100) {
          return 100;
        }
        return newProgress;
      });
    }, 50);

    // 3秒后触发完成
    pressTimerRef.current = setTimeout(() => {
      handleOk();
    }, HOLD_DURATION);
  }, []);

  const stopProgress = useCallback(() => {
    setProgress(0);
    
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
    }
    
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
      progressIntervalRef.current = null;
    }
  }, []);

  // 清理定时器
  React.useEffect(() => {
    return () => {
      if (pressTimerRef.current) {
        clearTimeout(pressTimerRef.current);
      }
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
      }
    };
  }, []);

  return (
    <Modal
      title={
        <>
          <img src={cdnUrl('/img/securityNoticeIcon.svg')} alt="" />
          <div>
            <h4>{t("securityNotice.title")}</h4>
            <p>{t("securityNotice.desc")}</p>
          </div>
        </>
      }
      visible={isModalVisible}
      onCancel={handleCancel}
      closeIcon={false}
      centered
      width={600}
      className="securityNoticeModal"
      footer={false
      //   [
      //   <Button key="ok" type="primary">
      //     <LongPressButton onLongPress={handleOk}>{t('我已知悉（长按关闭）')}</LongPressButton>
      //   </Button>,
      // ]
    }
    >
      <Form>
        <div>
          <p className="title">
          {t('securityNotice.suggestTips')}
          </p>
          <ul className="list">
            <li className="list-item" dangerouslySetInnerHTML={{ __html: t('securityNotice.itemTip1',{
              link1: `<a href='/${i18n.language}/token-batch-collection/bsc' target='_blank'>${t("nav.tokenBatchCollection")}</a>`,
              link2: `<a href='/${i18n.language}/wallet-asset-migrator/bsc' target='_blank'>${t("nav.walletAssetMigration")}</a>`,
            }) }}></li>
            {/* <li className="list-item" dangerouslySetInnerHTML={{ __html: t('securityNotice.itemTip2',{
            link1: `<a href='/${i18n.language}//bsc' target='_blank'>钱包助手</a>`}) 
            }}></li> */}
          </ul>
          <Button 
            className="ok-btn long-press-btn"
            onMouseDown={startProgress}
            onMouseUp={stopProgress}
            onMouseLeave={stopProgress}
            onTouchStart={startProgress}
            onTouchEnd={stopProgress}
          >
            <div className="progress-container">
              <div 
                className="progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
              <span className="btn-text">
                {t('securityNotice.btnText')}
              </span>
            </div>
          </Button>
          <p className="footer-text">{t("securityNotice.footerText")}</p>
        </div>
      </Form>
    </Modal>
  );
});

export default SecurityNoticeModal;
